import { createElement } from 'react';
import { Box } from '../BoxNew'
export var SpacerNew = function (_a) {
  var _b = _a.direction,
    direction = _b === void 0 ? 'vertical' : _b,
    _c = _a.size,
    size = _c === void 0 ? 0 : _c
  var height = direction === 'vertical' ? size : 0
  var width = direction !== 'vertical' ? size : 0
  return createElement(Box, { paddingTop: height, paddingLeft: width });
}
